import { client } from "@/http/client"

import { IPagingResponse, IRequestParams, IResponse } from "@/types/api"
import { IEmployee, IEmployeeChangePassword, IEmployeeCreate, IEmployeeUpdate } from "@/types/Employee/IEmployee"
import { IRole } from "@/types/IRole"

export const getEmployees = (
  params: IRequestParams
): Promise<IPagingResponse<IEmployee>> =>
  client.get("/Employees", {
    params
  })

export const getEmployeeById = (id: string): Promise<IResponse<IEmployee>> =>
  client.get(`/Employees/${id}`)

export const getEmployeeRoles = (): Promise<IPagingResponse<IRole>> =>
  client.get("/Employees/roles")

export const createEmployee = (user: IEmployeeCreate): Promise<IResponse<boolean>> =>
  client.post("/Employees", user)

export const updateEmployee = (user: IEmployeeUpdate): Promise<IResponse<boolean>> =>
  client.put("/Employees", user)

export const changePasswordEmployee = (user: IEmployeeChangePassword): Promise<IResponse<boolean>> =>
  client.put("/Employees/changePassword", user)

export const deleteEmployees = (ids: string[]): Promise<IResponse<boolean>> =>
  client.delete("/Employees", {
    data: {
      ids
    }
  })
